export default __webpack_public_path__ + "static/media/image5.a0b8acf7.jpg";